import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton-new-department-breadcrumb-card',
  templateUrl: './helpbutton-new-department-breadcrumb-card.component.html',
  styleUrls: ['./helpbutton-new-department-breadcrumb-card.component.scss']
})
export class HelpbuttonNewDepartmentBreadcrumbCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
